import styled from "styled-components";

const TooltipWrapper = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  font-size: 12px;
  padding: 6px;
  transform: translate(-50%, -50%);
  font-family: "AllianceNo2-Regular" !important;

  .tooltip-extra {
    font-family: "AllianceNo2-SemiBold" !important;
  }
`;

const TooltipHeader = styled.div`
  font-family: "AllianceNo2-SemiBold" !important;
  font-size: 13px;
  font-weight: 100 !important;
`;

const TooltipContent = styled.div`
  margin: 4px 0;
  display: flex;
  align-items: center;
`;

const TooltipKey = styled.div`
  margin: 0 10px;
`;

const TooltipLabel = styled.div`
  margin: 0 0px;
  width: 80px;
`;

const TooltipValues = styled.div`
  min-width: 280px;
  display: flex;
  margin-top: 10px;
`;

const TooltipValueWrapper = styled.div`
  width: 140px;
`;

const TooltipValue = styled.div`
  font-family: "AllianceNo2-SemiBold" !important;
`;

const TooltipColor = styled.div`
  background-color: ${(props) => props.bgColor};
  width: 12px;
  height: 12px;
  border: 1px solid #999;
`;

const TooltipEntries = styled.div`
margin: 10px 0;
 display: grid;
 grid-template-columns: calc(50% - 9px) calc(50% - 9px);
  gap: 4px 18px;
`;

const TooltipEntry = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
 > div {
 word-break: none;
 white-space: nowrap;
 }
 .tooltip-key {
 padding-right: 10px;
 }
 .tooltip-value {
 font-family: "AllianceNo2-SemiBold" !important;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 }
`;

const tooltipKeyMap = {
  "SUBSCRIBER-ID": "Sub ID",
  "BQN": "BQN",
  "ADDR": "Address",
  "BLOCK": "Block",
  "FL-ACTIVE": "Fl active",
  "FL-CREATED": "Fl created",
  "MBYTES": "MBytes",
  "CURR-Mbps": "Curr Mbps",
  "MEAN-Mbps": "Mean Mbps",
  "MAX-Mbps": "Max Mbp",
  "LIM-Mbps": "Lim Mbps",
  "RTT-ms": "RTT ms",
  "RTX": "Rtx",
  "POLICY-RATE": "Policy rate",
  "MAX-SPEED": "Max speed",
  "CONGEST": "Congest",
  "WARN": "Warn",
  "LIFETIME": "Lifetime",
  "GROUP-TYPE": "Group type",
  "ASSIGNMENT": "Assignment",
  "SUBS-PROVISIONED": "Subs provisioned",
  "SUBS-ACTIVE": "Subs active",
};

export const Tooltip = ({ interactionData, width, height, unit }) => {
  if (!interactionData || Object.keys(interactionData).length <= 1) {
    return null;
  }
  
  const { type, xLabel, yLabel, yColor, xPos, yPos, value, mean, sub, entity } =
  interactionData;

  if (type === "yLabel") {
    return (
      <div
        style={{
          height,
          width: width,
          position: "absolute",
          top: 0,
          left: 0,
          pointerEvents: "none",
        }}
      >
        <TooltipWrapper
          style={{
            position: "absolute",
            width: "auto",
            left: xPos + 120,
            top: yPos,
          }}
        >
          {entity==="subscriber-id" ? <TooltipHeader>{yLabel}</TooltipHeader>: null}
          {entity === "ip-address" || entity==="subscriber-group" ? <TooltipEntries>
          {sub && Object.entries(sub).map(([key, value]) => {
            if(['id', 'ADDR', "SUBSCRIBER-GROUP"].includes(key)){
              return null;
            }
            return <TooltipEntry key={`${key}-value`}>
              <div className="tooltip-key">{tooltipKeyMap[key] || key}</div>
              <div className="tooltip-value">{value}</div></TooltipEntry>
          })}
        </TooltipEntries> : null}
        <div className="tooltip-extra">Right click for details</div>
        </TooltipWrapper>
      </div>
    );
  }

  let xCorrection = 0;

  if (interactionData.xPos / width > 0.75) {
    xCorrection = -200;
  }
  if(width < 450){
    xCorrection = -100;
  }

  return (
    <div
      style={{
        height,
        width: width,
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none",
      }}
    >
      <TooltipWrapper
        style={{
          position: "absolute",
          width: "auto",
          left: xPos + xCorrection,
          top: yPos,
        }}
      >
        <TooltipHeader>{xLabel}</TooltipHeader>
        <TooltipContent>
          <TooltipColor bgColor={yColor}></TooltipColor>
          <TooltipKey>{yLabel}</TooltipKey>
        </TooltipContent>
        <TooltipValues>
          <TooltipValueWrapper>
          <TooltipLabel>Value</TooltipLabel>
            <TooltipValue>
              {value} {unit}
            </TooltipValue>
          </TooltipValueWrapper>
          <TooltipValueWrapper>
          <TooltipLabel>Mean</TooltipLabel>
            <TooltipValue>
              {mean} {unit}
            </TooltipValue>
          </TooltipValueWrapper>
        </TooltipValues>
      </TooltipWrapper>
    </div>
  );
};

export default Tooltip;
